import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import ChapterIntroductionEvent from "../event/ChapterIntroductionEvent";

export default class ChapterIntroductionCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     */
    constructor(dispatcher) {
        super(dispatcher);

        this._handleChapterIntroductionFinishBound = this._handleChapterIntroductionFinish.bind(this);
    }

    execute(evt) {
        const data = evt.params.data;
        const { content, contentPlayer } = data;

        this._content = content;
        /** @type {NGTScenarioPlayer} */
        this._contentPlayer = contentPlayer;

        this._chapterIntroductionScreenSkin = this.openScreen(SkinKeyRegistry.CHAPTER_INTRODUCTION_SCREEN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        }, {
            content,
        });

        this._dispatcher.addEventListener(ChapterIntroductionEvent.FINISH, this._handleChapterIntroductionFinishBound);
    }

    _handleChapterIntroductionFinish(evt) {
        this._dispatcher.removeEventListener(ChapterIntroductionEvent.FINISH, this._handleChapterIntroductionFinishBound);

        this.closeScreen(this._chapterIntroductionScreenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });

        this._contentPlayer.contentCompleted(this._content);
    }
}